// @ts-check
"use strict"

import React from "react"
import * as Sentry from "@sentry/react";
import { ChatMarkdown } from "./ChatBubble"
import { parseJsonToMarkdown } from "../chat-report-panel/utils"

import { RiExternalLinkLine } from "react-icons/ri";
import { byIdentifier } from "@minohealth/common/utils/ids";
import { useChatContext } from "@/services/chat-provider";

/**
 * @typedef {Object} ChatBubbleReportProps
 * @property {ChatMessage["report"]} messageReport
 * @property {import(".").ChatMessageBubbleProps["previewReport"]} previewReport
 * @property {string} isStreaming
*/

/** @param {ChatBubbleReportProps} props */
export default function ChatBubbleReport({ messageReport, previewReport, isStreaming }) {
  const { useActiveChatSessionId, useActiveChatSessionReports, useStreamingReport } = useChatContext()

  const [activeChatSessionId] = useActiveChatSessionId()
  const { data: chatReports } = useActiveChatSessionReports()
  // const streamingReport = useStreamingReport(activeChatSessionId)

  const reportObj = (() => {
    if (messageReport == null) return null
    if (typeof messageReport === "string") {
      return chatReports?.find(byIdentifier(messageReport))
    }
    return messageReport
  })()

  const reportText = (() => {
    if (reportObj == null) return null
    return reportObj.current
  })();

  function handleOpenReport() {
    if (isStreaming) {
      previewReport({ type: "stream", sessionId: activeChatSessionId })
      return
    }

    if(typeof messageReport === "string") {
      previewReport({ type: 'ref', ref: messageReport })
    } else {
      previewReport({ type: 'report', report: messageReport})
    }
  }

  function safeParseJsonToMarkdown(report = "") {
    try {
      return parseJsonToMarkdown(report)
    } catch (err) {
      Sentry.captureException(err, {
        extra: {
          context: 'ChatBubbleReport - parseJsonToMarkdown',
          messageReport: messageReport || 'undefined',
          reportLength: report?.length || 0,
          isStreamingReport: reportObj?.chunks != null
        }
      });
      return null
    }
  }

  if (reportObj == null) return null

  return (
    <div className="chat-bubble__report">
      <div className="chat-bubble__report-content">
        <ChatMarkdown>{safeParseJsonToMarkdown(reportText)}</ChatMarkdown>
      </div>

      <div className="chat-bubble__report-actions">
        <button
          type="button"
          className="chat-bubble__report-open-btn"
          onClick={handleOpenReport}
        >
          <span>Open Report</span>
          <RiExternalLinkLine />
        </button>
      </div>
    </div>
  )
}
